import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { PrivacyPolicys } from "../../utils/apis/privacypolicy/PrivacyPolicy";

const Privacy_Policy = () => {
  const navigate = useNavigate();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [policy, setPolicy] = useState([]);
  const [activeSection, setActiveSection] = useState("");

  const getPolicy = async () => {
    const res = await PrivacyPolicys();

    if (res?.success) {
      setPolicy(res?.data || []);
    }
  };

  useEffect(() => {
    getPolicy();
  }, []);

  //  const handleScroll = (id, index) => {
  //   console.log("Clicked index:", index);
  //   setActiveSection(id);

  //   const container = document.querySelector(".terms-content");

  //   if (!container) return;

  //   // First 5 tabs → scroll to top
  //   if (index <= 5) {
  //     console.log("Scroll to top");
  //     container.scrollTo({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //     window.scrollTo({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

  //   // Scroll to section
  //   const section = document.getElementById(id);
  //   if (section) {
  //     const offsetTop = section.offsetTop;
  //     const offset = 60;

  //     container.scrollTo({
  //       top: offsetTop - offset,
  //       behavior: "smooth",
  //     });
  //   }
  // };

  const handleScroll = (id, index) => {
    setActiveSection(id);

    const container = document.querySelector(".terms-content");
    const section = document.getElementById(id);

    if (!container) return;

    // If first 5 tabs → scroll to top
    if (index < 0) {
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }

    // Scroll to selected section
    if (section) {
      const containerTop = container.offsetTop;
      const sectionTop = section.offsetTop;

      const offset = 40;

      container.scrollTo({
        top: sectionTop - containerTop - offset,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <section className="privacy_policy term_conditions residential_service">
        <div className="breadcrumb_wrapper custom_container">
          <span className="breadcrumb_link" onClick={() => navigate("/")}>
            Home
          </span>
          <span className="breadcrumb_separator"> &gt; </span>
          <span className="breadcrumb_active">Privacy policy</span>
        </div>

        <div className="custom_container">
          <section className="terms-wrapper">
            <aside className="terms-sidebar">
              <div className="jump-box">
                <h3>Content</h3>
                <ul>
                  {policy.map((item, index) => (
                    <div
                      key={item.id}
                      className={`list_holder ${
                        activeSection === `section${index}` ? "active" : ""
                      }`}
                      //  onClick={() => handleScroll(`section${index}`, index)}

                      onClick={() => handleScroll(`section${index}`, index)}
                    >
                      <li>
                        {index + 1}. {item.name}
                      </li>
                    </div>
                  ))}
                </ul>
              </div>

              <div className="social_icons_div">
                <p>Follow us on :</p>

                <div className="footer_links">
                  {[
                    { icon: faFacebookF, link: "https://www.facebook.com" },
                    { icon: faInstagram, link: "https://www.instagram.com" },
                    {
                      icon: faLinkedinIn,
                      link: " https://www.linkedin.com/company/hbctc/",
                    },
                    // { icon: faXTwitter, link: "https://www.twitter.com" },
                  ].map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      className="footer_link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="icon_holder">
                        <FontAwesomeIcon icon={item.icon} />
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </aside>

            <div className="terms-content">
              <div className="terms_header">
                <h1 className="terms_title">Privacy policy</h1>
                {/* <p className="effective_date">Effective Date:29 JAN 2025</p> */}
              </div>

              {/* <p className="header_text">
                Your privacy is important to us. This Privacy Policy explains
                how we collect, use, disclose, & protect your information when
                you visit or use our website, services, or applications. By
                accessing our platform, you agree to the terms of this Privacy
                Policy.
              </p> */}
              {policy.map((item, index) => (
                <div
                  id={`section${index}`}
                  className="terms-section"
                  key={item.id}
                >
                  <h2>
                    {index + 1}. {item.name}
                  </h2>

                  <p>{htmlToReactParser.parse(item.description)}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default Privacy_Policy;
